export default {
    en: {
        payment: {
            paid: 'Paid',
            debt: 'Debt',
            bonus: 'Bonus',
            canceled: 'Canceled',
            cash: 'Cash',
            card: 'Card',
            bank: 'Bank',
            mixed: 'Mixed'
        },
        notification: {
            fewItems: "You have a few items left in the storage. Please, bring some more items",
        },
        main: {
            newSale: 'New Sale',
            filter: {
                title: 'Filters',
                all: 'All',
                paid: 'Paid',
                debt: 'Debt',
                bonus: 'Bonus',
                canceled: 'Canceled',
                apply: 'Apply'
            },
            alert: {
                title: "Are you sure?",
                text: "Do you really want to delete the sale?",
                yesBtn: 'Yes, delete it!',
                cancel: "Cancel!"
            },
            table: {
                img: 'Image',
                name: 'Name',
                code: 'Code',
                dimension: 'Dimension',
                piece: 'Quantity',
                price: 'Price',
                profit: 'Profit',
                brand: 'Brand',
                date: 'Date',
                status: 'Status',
                edit: 'Edit'
            },
            title: 'No sales yet?',
            context: 'Let get started to sale your product! Click Sale Now button.',
            action: 'Sale Now'
        },
        sale: {
            saleTab: 'Sale',
            detailTab: 'Details',
            nextBtn: 'Next',
            backBtn: 'Back',
            paymentTitle: 'Payment Type',
            paymentTitle2: 'Payment Status',
            paymentTitle3: 'Note',
            cash: 'Cash',
            card: 'Card',
            bank: 'Bank',
            mixed: 'Mixed',
            paid: 'Paid',
            debt: 'Debt',
            bonus: 'Bonus',
            canceled: 'Canceled',
            due: 'Due amount',
            dueChange: 'Change Amount',
            date: 'Date',
            price: 'Price',
            pieces: 'Quantity',
            noteText: 'Special Note...\n\n - Frequent customer \n - My brother',
            button: 'Sell',
            alertText: 'There is no item left in the stock!',
            alertBtn: 'View product',
            customer: {
                ctTitle: 'Customer Details',
                ctName: 'Full Name',
                ctDue: 'Debt amount',
                ctPhone: "Customer's Phone",
                ctAddress: "Customer's Address",
                ctDate: "Due Date"
            },
        },
        title: 'Specifications',
        design: 'Design',
        quality: 'Quality',
        category: 'Category',
        color: 'Color',
        dimension: 'Dimension',
        total: 'Total',
        importPrice: 'Import Price',
        salePrice: 'Sale Price',
        inStock: 'In Stock',
        info: 'Extra information',
        buttons: {
            saleBtn: 'Sell Now',
            edit: 'Edit',
            deleteBtn: 'Delete',
        }
    },
    uz: {
        payment: {
            paid: "To'langan",
            debt: 'Qarz',
            bonus: 'Bonus',
            canceled: "Bekor Bo'lgan",
            cash: 'Naqt',
            card: 'Karta',
            bank: 'Bank',
            mixed: 'Aralash'
        },
        notification: {
            fewItems: "Omborda kam mahsulot qoldi. Iltimos, mahsulotlar olib kelishni unutming!",
        },
        main: {
            newSale: 'Sotish',
            filter: {
                title: 'Filterlash',
                all: 'Barchasi',
                paid: "To'langan",
                debt: 'Qarz',
                bonus: 'Bonus',
                canceled: "Bekor Bo'lgan",
                apply: 'Tasdiqlash'
            },
            alert: {
                title: "Bunga aminmisiz?",
                text: "Haqiqatan ham xaridni yo'q qilmoqchimisiz?",
                yesBtn: "Ha, o'chir!",
                cancel: "Bekor qil!"
            },
            table: {
                img: 'Rasm',
                name: 'Nomi',
                code: 'Kod',
                dimension: "O'lchami",
                piece: 'Miqdori',
                price: 'Narxi',
                profit: 'Sof Foyda',
                brand: 'Brand',
                date: 'Sana',
                status: 'Holati',
                edit: 'Tahrirlash'
            },
            title: 'No sales yet?',
            context: 'Let get started to sale your product! Click Sale Now button.',
            action: 'Sale Now'
        },
        sale: {
            saleTab: 'Sotish',
            detailTab: 'Detallar',
            paymentTitle: 'To\'lov turi',
            paymentTitle2: 'To\'lov holati',
            paymentTitle3: 'Eslatma',
            nextBtn: 'Next',
            backBtn: 'Back',
            cash: 'Naqd',
            card: 'Karta',
            bank: 'Bank',
            mixed: 'Aralash',
            paid: 'To\'landi',
            debt: 'Qarz',
            bonus: 'Bonus',
            canceled: 'Bekor Qilish',
            due: 'Qoldiq miqdori',
            dueChange: "Miqdorni o'zgartirish",
            date: 'Sana',
            price: 'Narxi',
            pieces: 'Miqdor',
            noteText: 'Maxsus eslatma...\n\n - Doimiy mijoz \n - Akam uchun',
            button: 'Sotish',
            alertText: 'Omborda bu mahsulotdan qolmagan!',
            alertBtn: "Mahsulotni ko'rish",
            customer: {
                ctTitle: "Mijoz ma'lumotlari",
                ctName: 'F.I.SH',
                ctDue: 'Qarz miqdori',
                ctPhone: "Mijozning telefoni",
                ctAddress: "Mijozning manzili",
                ctDate: "To'lov muddati"
            }

        },
        title: 'Ma\'lumotlar',
        design: 'Dizayn',
        quality: 'Sifati',
        category: 'Kategoriya',
        color: 'Rangi',
        dimension: 'O\'lchamlari',
        total: 'Umumiy',
        importPrice: 'Import narxi',
        salePrice: 'Sotish narxi',
        inStock: 'Omborda',
        info: "Qo'shimcha ma'lumotlar",
        buttons: {
            saleBtn: 'Sotish',
            edit: 'Tahrirlash',
            deleteBtn: 'O\'chirish',
        }
    },
    ru: {
        payment: {
            paid: 'Оплаченных',
            debt: 'Долг',
            bonus: 'Бонус',
            canceled: 'Отменено',
            cash: 'Наличные',
            card: 'Карта',
            bank: 'Банк',
            mixed: 'Разный'
        },
        notification: {
            fewItems: "У вас осталось несколько товаров на складе. Пожалуйста, принесите еще несколько предметов",
        },
        main: {
            newSale: 'Продать сейчас',
            filter: {
                title: 'Фильтр',
                all: 'Все',
                paid: 'Оплачено',
                debt: 'Долг',
                bonus: 'Бонус',
                canceled: 'Отменено',
                apply: 'Применять'
            },
            alert: {
                title: "Вы уверены?",
                text: "Вы действительно хотите удалить продажу?",
                yesBtn: 'Да, удали это!',
                cancel: "Отмена!"
            },
            table: {
                img: 'Изображение',
                name: 'Название',
                code: 'Код',
                dimension: 'Размеры',
                piece: 'Количество',
                price: 'Цена',
                profit: 'Прибыль',
                brand: 'Марка',
                date: 'Дата',
                status: 'Статус',
                edit: 'Редактировать'
            },
            title: 'No sales yet?',
            context: 'Let get started to sale your product! Click Sale Now button.',
            action: 'Sale Now'
        },
        sale: {
            saleTab: 'Продажа',
            detailTab: 'Детали',
            paymentTitle: 'Тип платежа',
            paymentTitle2: 'Статус оплаты',
            paymentTitle3: 'Записка',
            nextBtn: 'Next',
            backBtn: 'Back',
            cash: 'Наличные',
            card: 'Карта',
            bank: 'Банк',
            mixed: 'Разный',
            paid: 'Оплаченный',
            debt: 'Долг',
            bonus: 'Бонус',
            canceled: 'Отменен',
            due: 'Сумма долга',
            dueChange: 'Изменить сумму',
            date: 'Дата',
            price: 'Цена',
            pieces: 'Количество',
            noteText: 'Специальное примечание...\n\n - Частый клиент \n - Мой брат',
            button: 'Продать',
            alertText: 'На складе этого товара нет!',
            alertBtn: 'Посмотреть продукт',
            customer: {
                ctTitle: 'Данные клиента',
                ctName: 'ФИО',
                ctDue: 'Сумма долга',
                ctPhone: "Телефон клиента",
                ctAddress: "Адрес клиента",
                ctDate: "Срок оплаты"
            }
        },
        title: 'Характеристики',
        design: 'Дизайн',
        quality: 'Качество',
        category: 'Категория',
        color: 'Цвет',
        dimension: 'Размер',
        total: 'Общий размер',
        importPrice: 'Импортная цена',
        salePrice: 'Цена продажи',
        inStock: 'В склад',
        info: 'Дополнительная информация',
        buttons: {
            saleBtn: 'Продать',
            edit: 'Редактировать',
            deleteBtn: 'Удалять',
        }
    },
}